/**
 * Asset views reducer
 */

import _merge from "lodash/merge";
import { cloneDeep, merge } from "lodash";
import { UPDATE_ASSET_VIEW_SUCCESS } from "../../actions/actionTypes";

const fieldsReducer = (state = {}, action) => {
  let views;
  try {
    views = action.response.entities.views;
  } catch (error) {
    // That's ok
  }
  switch (action.type) {
    case UPDATE_ASSET_VIEW_SUCCESS: {
      const { viewId } = action;
      const newView = cloneDeep(views[viewId]);
      return {
        ...state,
        [Number(viewId)]: newView,
      };
    }
    default: {
      if (views) {
        return merge({}, state, views);
      }
      return state;
    }
  }
};

export default fieldsReducer;
